import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import type {
	usePageTreeSearchQueryQuery$data,
	usePageTreeSearchQueryQuery$variables,
} from './__generated__/usePageTreeSearchQueryQuery.graphql.ts';

export const usePageTreeSearchQuery = (
	spaceKey: string,
	title: string,
	validateSpace: boolean,
	skip?: boolean,
): {
	data: usePageTreeSearchQueryQuery$data | undefined;
	error: ApolloErrorInterop | undefined;
	loading: boolean;
} => {
	const { data, error, loading } = useQueryInterop<
		usePageTreeSearchQueryQuery$data,
		usePageTreeSearchQueryQuery$variables
	>(
		graphql`
			query usePageTreeSearchQueryQuery(
				$spaceKey: String!
				$title: String!
				$validateSpace: Boolean!
			) {
				space(key: $spaceKey) @include(if: $validateSpace) {
					id
				}
				content(spaceKey: $spaceKey, title: $title, type: "page") {
					nodes {
						id
					}
				}
			}
		`,
		{
			variables: { spaceKey, title, validateSpace },
			skip: skip || !spaceKey || !title,
			fetchPolicy: 'cache-first',
		},
	);

	return { data, error, loading };
};
